import React, { memo } from 'react'
import { Typography } from '@mui/material'
import { ProductsMinor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { getTags } from 'src/selectors/tag'
import { TableSelect } from './TableSelect'
import { useManageTags } from 'src/components/tags/useManageTags'

interface Props {
  selectedTags: Array<string>
  setSelectedTags(statusFilter: Array<string>): void
  triggerDataTestId?: string
  clearAllDataTestId?: string
  manageOptionsDataTestId?: string
}

const TableTagsSelectComponent = ({
  selectedTags,
  setSelectedTags,
  triggerDataTestId,
  clearAllDataTestId,
  manageOptionsDataTestId,
}: Props) => {
  const tags = useSelector(getTags)

  const { openManageTags } = useManageTags()

  return (
    <TableSelect<string>
      title="Tags"
      selectedValues={selectedTags}
      icon={<ProductsMinor width={20} />}
      options={tags.map((item) => ({
        value: item.name,
        label: item.name,
        component: <Typography variant="subtitle1">{item.name}</Typography>,
      }))}
      emptyText="Create a new tag to manage your fleet efficiently"
      onEmpty={openManageTags}
      onSelect={setSelectedTags}
      triggerDataTestId={triggerDataTestId}
      clearAllDataTestId={clearAllDataTestId}
      manageOptionsDataTestId={manageOptionsDataTestId}
    />
  )
}

export const TableTagsSelect = memo(TableTagsSelectComponent)
